//TODO:hmm should this not be in utils/ ?

type ButtonData = { onClick: () => void; label: string };
type LinkData = { href: string; label: string };
export type ActionOption = ButtonData | LinkData;

//TODO:hmm maybe ActionOption should just have a mandatory isButton/isLink field as opposed to using isButton()
export function isButton(thing: ButtonData | LinkData): thing is ButtonData {
  return (thing as ButtonData).onClick !== undefined;
}
